import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import styles from './Footer.module.css';

/**
 * Sosyal medya bağlantıları. Gerçek hesap adresleriyle doldurulduğunda
 * footer'da otomatik olarak ikon satırı görünür. Boşken satır gizlenir.
 * Örn: { key: 'instagram', label: 'Instagram', url: 'https://instagram.com/...' }
 */
const SOCIAL_LINKS = [];

const SOCIAL_ICONS = {
  instagram: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r="0.6" fill="currentColor" />
    </svg>
  ),
  x: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M18.244 2H21.5l-7.5 8.57L23 22h-6.93l-5.43-7.1L4.4 22H1.14l8.02-9.17L1 2h7.1l4.9 6.48L18.244 2Zm-2.43 18h1.92L7.27 4h-2.06l10.6 16Z" />
    </svg>
  ),
  youtube: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <rect x="2" y="5" width="20" height="14" rx="4" />
      <path d="M10 9.5v5l4.5-2.5L10 9.5Z" fill="currentColor" stroke="none" />
    </svg>
  ),
  linkedin: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM3 9h4v12H3V9Zm7 0h3.8v1.7h.05c.53-.95 1.83-1.95 3.77-1.95C21.4 8.75 22 11 22 14.1V21h-4v-6.1c0-1.45-.03-3.3-2-3.3-2 0-2.3 1.57-2.3 3.2V21h-4V9Z" />
    </svg>
  ),
};

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.grid}>
          {/* Marka kolonu */}
          <div className={styles.brandCol}>
            <Link to="/" className={styles.logo} aria-label="3D Era">
              <span className={styles.logo3d}>3D</span>
              <span className={styles.logoEra}>Era</span>
            </Link>
            <p className={styles.tagline}>{t('footer.tagline')}</p>

            {SOCIAL_LINKS.length > 0 && (
              <div className={styles.social} aria-label={t('footer.followUs')}>
                {SOCIAL_LINKS.map((s) => (
                  <a
                    key={s.key}
                    href={s.url}
                    className={styles.socialLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={s.label}
                  >
                    {SOCIAL_ICONS[s.key] || s.label}
                  </a>
                ))}
              </div>
            )}
          </div>

          {/* Keşfet kolonu */}
          <nav className={styles.linkCol} aria-label={t('footer.exploreHeading')}>
            <h3 className={styles.colHeading}>{t('footer.exploreHeading')}</h3>
            <Link to="/marketplace" className={styles.link}>{t('footer.marketplace')}</Link>
            <Link to="/become-seller" className={styles.link}>{t('footer.becomeSeller')}</Link>
            <Link to="/blog" className={styles.link}>{t('footer.blog')}</Link>
            <Link to="/about" className={styles.link}>{t('footer.about')}</Link>
            <Link to="/contact" className={styles.link}>{t('footer.contact')}</Link>
          </nav>

          {/* Yasal & Destek kolonu */}
          <nav className={styles.linkCol} aria-label={t('footer.legalLinks')}>
            <h3 className={styles.colHeading}>{t('footer.legalHeading')}</h3>
            <Link to="/sss" className={styles.link}>{t('footer.faq')}</Link>
            <Link to="/gizlilik-politikasi" className={styles.link}>{t('footer.privacy')}</Link>
            <Link to="/kullanim-kosullari" className={styles.link}>{t('footer.terms')}</Link>
            <Link to="/mesafeli-satis-sozlesmesi" className={styles.link}>{t('footer.distanceSales')}</Link>
            <Link to="/kvkk-aydinlatma" className={styles.link}>{t('footer.kvkk')}</Link>
          </nav>
        </div>

        <div className={styles.copyright}>
          <p>&copy; {currentYear} 3D Era. {t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
